// extracted by mini-css-extract-plugin
export default {"parentTitle":"documentsTable_parentTitle__Q4IDc"};